import type { ForcedMovementSourceCollectionInput } from '../types';
import { orderForcedMovementSources } from './forced-movement-source-priority';

const SOURCE_KEYS = ['source_item_id', 'source_name', 'source_kind', 'source_origin_item_id',
    'source_origin_name', 'source_status_id', 'source_inventory_id', 'source_thumb_url'] as const;
const IDENTITY_KEYS = ['source_item_id', 'source_status_id', 'source_inventory_id', 'source_kind', 'source_name'] as const;

/** Collect resolved metadata in discovery order; first identity wins before stable priority sorting. */
export function collectForcedMovementSourceCandidates(input: ForcedMovementSourceCollectionInput): Record<string, string>[] {
    if (input.layerName !== 'force_move_resistance' && input.layerName !== 'immune_to_forced_movement') return [];
    const seen = new Set<string>();
    const candidates = [];
    for (const source of input.candidates) {
        const normalized: Record<string, string> = {};
        for (const key of SOURCE_KEYS) {
            const value = source[key];
            if (value !== undefined && value !== null && value !== '' && value !== '0') normalized[key] = value;
        }
        if (Object.keys(normalized).length === 0) continue;
        // Delimiter collisions are retained deliberately: this is PHP's identity, not a JSON tuple.
        const identity = IDENTITY_KEYS.map(key => normalized[key] ?? '').join('|');
        if (seen.has(identity)) continue;
        seen.add(identity);
        const sourceKind = normalized.source_kind ?? null;
        candidates.push({ source: normalized, sourceKind,
            isCreatureSubtype: sourceKind !== null && input.subtypeKinds.includes(sourceKind) });
    }
    return orderForcedMovementSources(candidates).map(candidate => candidate.source);
}
